module.exports = __webpack_public_path__ + "img/tick.c5e481b5.png";